define('webshopLandingpagesDetailBodyView',[
  'app',
  'module',
  'marionette',
  'underscore',
  'rolesMixin',
  'tabsViewView',
  'webshopLandingpagesDetailBodyLandingpageView',
  'webshopLandingpagesDetailBodyUrlsView',
  'webshopLandingpagesDetailBodyTextsView'
], function (
  App,
  Module,
  Marionette,
  _,
  RolesMixin,
  TabsView
) {
  'use strict';

  Module.exports = TabsView.extend({
    selectedTab: 'landingpage',

    tabs: function () {
      return [{
        name: 'landingpage',
        url: '',
        title: _.i18n('common.landingpage'),
        role: RolesMixin.DASHBOARD_WEBSHOP_LANDINGPAGES_LANDINGPAGE,
        view: 'webshopLandingpagesDetailBodyLandingpageView'
      }, {
        name: 'texts',
        url: 'texts',
        title: _.i18n('webshop.landingpages.texts.tabTitle'),
        role: RolesMixin.DASHBOARD_WEBSHOP_LANDINGPAGES_TEXTS,
        view: 'webshopLandingpagesDetailBodyTextsView'
      }, {
        name: 'urls',
        url: 'urls',
        title: _.i18n('common.urls'),
        role: RolesMixin.DASHBOARD_WEBSHOP_LANDINGPAGES_URLS,
        view: 'webshopLandingpagesDetailBodyUrlsView'
      }];
    }
  });
});

